import { z } from "zod";

import { ForenkletEllerDetaljertEnum } from "../../reportEnums.js";

export const ZForenkletEllerDetaljertEnumSchema = z.nativeEnum(ForenkletEllerDetaljertEnum).nullable();
